export default __webpack_public_path__ + "static/media/sg_flashpay_fees_backgound.7566be59.png";